import { render, staticRenderFns } from "./CustomerAllOrderStatus.vue?vue&type=template&id=2925d4c5&"
import script from "./CustomerAllOrderStatus.vue?vue&type=script&lang=js&"
export * from "./CustomerAllOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAllOrderStatus.vue?vue&type=style&index=0&id=2925d4c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports